
export const getQueryParameter = (paramKey :string) => {
  const urlParams = new URLSearchParams(window.location.search);

  return urlParams.get(paramKey);
};
